let audioCtx: AudioContext | null = null;

function getContext(): AudioContext {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
  }
  return audioCtx;
}

function playTone(freq: number, type: OscillatorType, duration: number, volume = 0.12) {
  try {
    const ctx = getContext();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(freq, ctx.currentTime);
    gain.gain.setValueAtTime(volume, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
    osc.connect(gain).connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + duration);
  } catch {
    // 静默失败
  }
}

export function sfxCorrect() {
  playTone(880, 'sine', 0.15);
  setTimeout(() => playTone(1100, 'sine', 0.2), 150);
}

export function sfxWrong() {
  playTone(200, 'triangle', 0.3, 0.06);
}

export function sfxNewTitle() {
  playTone(523, 'sine', 0.1);
  setTimeout(() => playTone(659, 'sine', 0.1), 120);
  setTimeout(() => playTone(784, 'sine', 0.2), 240);
}
